import styled from 'styled-components';
import MuiAlert from '../../Alert';

export const Alert = styled(MuiAlert)`
  justify-content: center;
  text-align: left;
`;
